
export const DaSergioLogoFileName192x233 = 'logo-da-sergio-182x210.png';
export const DaSergioLogoFileName100x100 = 'logo-da-sergio-100x100.png';
export const DaSergioTextFileName = 'text-da-sergio.png';
export const DaSergioBackgroundImageFileName = 'wood-background.png';
export const DaSergioFaceBookUrl = 'https://www.facebook.com/pizzeriaristorantedasergio';
export const DaSergioAlternateTextForImage = 'da Sergio';

export const WkoAllergensInfoURL = 'https://www.wko.at/branchen/tourismus-freizeitwirtschaft/gastronomie/WKO_ALLERGENE_PLAKAT-A3_OOe.PDF';
